"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.server = exports.entity = exports.player = void 0;
const vec3_1 = require("vec3");
const chalk_1 = __importDefault(require("chalk"));
const user_error_1 = __importDefault(require("../user_error"));
const player = function (player, serv) {
    function attackEntity(entityId) {
        const attackedEntity = serv.entities[entityId];
        const attackedPlayer = attackedEntity.type === 'player' ? attackedEntity : undefined;
        if (!attackedEntity || (attackedPlayer && attackedPlayer.gameMode !== 0))
            return;
        player.behavior('attack', {
            attackedEntity,
            velocity: attackedEntity.position.minus(player.position).plus(new vec3_1.Vec3(0, 0.5, 0)).scaled(5)
        }, (o) => o.attackedEntity.takeDamage(o));
    }
    player._client.on('use_entity', ({ mouse, target } = {}) => {
        if (!serv.entities[target]) {
            let dragon = target - 1;
            while (dragon >= target - 7 && !serv.entities[dragon]) {
                dragon--;
            }
            if (serv.entities[dragon] && serv.entities[dragon].entityType === 63) {
                target = dragon;
            }
        }
        if (mouse === 1) {
            attackEntity(target);
        }
    });
};
exports.player = player;
const entity = function (entity, serv) {
    entity.takeDamage = ({ sound = 'game.player.hurt', damage = 1, velocity = new vec3_1.Vec3(0, 0, 0), maxVelocity = new vec3_1.Vec3(4, 4, 4), animation = true }) => {
        entity.updateHealth(entity.health - damage);
        serv.playSound(sound, entity.world, entity.position);
        entity.sendVelocity(velocity, maxVelocity);
        if (entity.health <= 0) {
            if (animation) {
                entity._writeOthers('entity_status', {
                    entityId: entity.id,
                    entityStatus: 3
                });
            }
            if (entity.type !== 'player') {
                delete serv.entities[entity.id];
            }
        }
        else if (animation) {
            entity._writeOthers('animation', {
                entityId: entity.id,
                animation: 1
            });
        }
    };
    entity.kill = (options = {}) => {
        entity.takeDamage({ damage: entity.health, ...options });
    };
    if (entity.type !== 'player') {
        entity.updateHealth = (health) => {
            entity.health = health;
        };
    }
};
exports.entity = entity;
const server = function (serv) {
    serv.commands.add({
        base: 'kill',
        info: 'Kill entities',
        usage: '/kill <selector>|<player>',
        tab: ['player'],
        parse(str) {
            return str || false;
        },
        action(sel, ctx) {
            if (sel !== '') {
                if (serv.getPlayer(sel) !== null) {
                    serv.getPlayer(sel).kill();
                    serv.info(`Killed ${chalk_1.default.bold(sel)}`);
                }
                else {
                    const arr = serv.selectorString(sel);
                    if (arr.length === 0)
                        throw new user_error_1.default('Could not find player');
                    arr.forEach(entity => {
                        entity.kill();
                        serv.info(`Killed ${chalk_1.default.bold(entity.type === 'player' ? entity.username : entity.name ?? '<unknown>')}`);
                    });
                }
            }
            else {
                if (ctx.player)
                    ctx.player.kill();
                else
                    serv.err('Can\'t kill console');
            }
        }
    });
    serv.commands.add({
        base: 'damage',
        info: 'Applies damage to the specified entities',
        usage: '/damage',
        tab: ['player', 'number'],
        parse(string, ctx) {
            return string.split(' '); // todo validate
        },
        action(data, ctx) {
            const players = serv.getPlayers(data[0], ctx.player);
            for (const player of players) {
                player.takeDamage({ damage: +data[1], });
            }
        },
    });
};
exports.server = server;
